import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { Flex } from "@jsq/ds/core";
import { toDbId } from "../../../utils/graphql_utils";
import { ArenaDashboard } from "./ArenaDashboard";
import { EntityDashboard } from "./EntityDashboard";
import { PositionDashboard } from "./PositionDashboard";
import { pageContainer } from "./styles_vanilla.css";

/**
 * Routing shell for the three-level compliance dashboard.
 * Each child owns its own header, breadcrumbs, tabs, and navigation via useDashboardNavigation.
 *
 *   Arena    → /compliance
 *   Entity   → /compliance/entity/:eid
 *   Position → /compliance/entity/:eid/position/:pid
 */
export const ComplianceDashboardPage = ({
  arenaId,
  arenaName,
}: {
  arenaId: string;
  arenaName: string;
}) => {
  const { path } = useRouteMatch();
  const arenaDBId = toDbId(arenaId);

  return (
    <Flex className={pageContainer} flexDirection="column">
      <Switch>
        <Route path={`${path}/entity/:eid/position/:pid`}>
          <PositionDashboard arenaId={arenaDBId} arenaName={arenaName} />
        </Route>

        <Route path={`${path}/entity/:eid`}>
          <EntityDashboard arenaId={arenaDBId} arenaName={arenaName} />
        </Route>

        <Route path={path} exact>
          <ArenaDashboard
            arenaId={arenaDBId}
            arenaName={arenaName}
            launchHome={() => {
              window.location.assign("/");
            }}
          />
        </Route>
      </Switch>
    </Flex>
  );
};
